export default "__VITE_ASSET__kQ226eTv__"